import { atom } from "recoil";
import { PlanKey } from "../components/task/payment/planTypes";

export interface UserType {
  accessToken?: string;
  role?: string;
  nickname?: string;
  authenticateType?: string;
  isNicknameChangeRequired?: boolean;
  email?: string;
  userId?: number;
  programStartedAt?: string;
  hasPraised?: boolean;
  surveySeq?: number;
  dayNumber?: number;
  subscription?: {
    hasStarted: boolean;
    isSubscribing: boolean;
    expiryDaysLeft?: number;
    latestPaidAt?: string;
    expirationAt?: string;
    canceledAt?: string; // 인앱결제만
    renewedAt?: string; // 인앱결제만
    bonusDays?: number;
    isFirstSubscription: boolean;
    hasBeenRefunded: boolean;
    hasBeenPlanUpgraded: boolean;
  };
  isMandatoryTaskForRefundDone?: boolean;
  // 담당 코치 상태. 퇴사가 최우선이며 서버의 코치 재배정 사유 우선순위와 같다.
  assignedCoachStatus?: "inactive" | "master_unavailable" | "available";
  isEarlyAccess?: boolean;
  assignedCoachName?: string;
  isOnboardingRequired?: boolean;
  isCommitmentRequired?: boolean;
  onboardingType?: string;
  benefit?: string;
  appId?: string;
  pricingModel?: string;
  programType?: string;
  lastTaskUpdatedAt?: string;
  todayTaskUpdateCount?: number;
  weeklyTaskUpdateCount?: number;
  isCarePass?: boolean;
  trackId?: string;
  plan?: PlanKey;
  paymentPageType?: string;
  refundPolicyType?: string;
  segmentType?: string;
  isInsider?: boolean;
  isStoreReviewer?: boolean;
  isWebFunnelRegister?: boolean;
  isDemographicRequired?: boolean;
  promotion?: string;
  referralCode?: string;
  referralName?: string;
  referralDisplayName?: string;
  // 레퍼럴 코드 유형 (affiliate=제휴/discount=단순할인, 레퍼럴로 진입한 경우만)
  referralCodeType?: "affiliate" | "discount";
}

export const userAtom = atom<UserType | undefined>({
  key: "user",
  default: undefined,
  effects: [
    ({ setSelf, onSet }) => {
      const savedData = localStorage.getItem("user");
      // setSelf: atom 값을 설정 혹은 재설정
      if (savedData) setSelf(JSON.parse(savedData));

      // atom이 변화가 감지될 때 작동, Storage에 데이터 저장
      // setSelf에 의해서는 작동하지 않음
      onSet((newValue, _, isReset) => {
        isReset
          ? localStorage.removeItem("user")
          : localStorage.setItem("user", JSON.stringify(newValue));
      });
    },
  ],
});
